import { useAuthStore } from '@/stores/auth-store'

export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    error,
    validationErrors,
    login,
    register,
    logout,
    checkSession,
    verifyEmail,
    resendVerificationEmail,
    clearError,
    clearValidationErrors,
  } = useAuthStore()

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    validationErrors,
    login,
    register,
    logout,
    checkSession,
    verifyEmail,
    resendVerificationEmail,
    clearError,
    clearValidationErrors,
  }
}
